import { useContext } from 'react';


import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import classNames from 'classnames';
import { AccountContext } from '../context/account';
import { PaymentMethod } from '../core/global';
import useLoggedIn from '../hooks/useLoggedIn';
import styles from "../styles/components/project-selector.module.scss";
import { WarningMessage } from './error-message';

interface PaymentSelectorProps {
  id: string
  compact?: boolean
  className?: string
}

export const PaymentSelector = ({
  id,
  compact = false,
  className,
}: PaymentSelectorProps) => {

  const {
    userPaymentMethods,
    setUserActivePaymentMethod,
    userActivePaymentMethod,
  } = useContext(AccountContext);

  const userIsLoggedIn = useLoggedIn();
  
  if (!userIsLoggedIn) {
    return null
  }
  
  if (!userPaymentMethods || 
    (Array.isArray(userPaymentMethods) && userPaymentMethods.length === 0)
  ) {
    return <WarningMessage message={'We are really sorry, but there are no payment methods available at the moment. Please contact our team if you wish to purchase data.'} />
  }

  return (
    <>
      <FormControl 
        className={classNames(className, styles.formControl, {
          [styles.compact]: compact
        })}
        size={compact? 'small': "medium"}
      >
        <InputLabel id={id}>Payment method</InputLabel>
        {userPaymentMethods && <Select
          labelId={id}
          id={id}
          label='Payment method'
          value={`${userActivePaymentMethod === null ? null : userActivePaymentMethod.id}`}
          onChange={(event: SelectChangeEvent) => {
            const { value } = event.target
            if (userPaymentMethods) {
              const found = userPaymentMethods.find( item => item.id === value)
              if (found) {
                setUserActivePaymentMethod(found)
              }
            }
            }
          }
        >
          {userPaymentMethods.map((item: PaymentMethod) => {
            const {id, title} = item
            return <MenuItem key={id} value={id}>{title}</MenuItem>
          })}
        </Select>
      }
      </FormControl>
    </>
  )
}
